import { ModuleLayout, SectionMessage, Space } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetchDeliveryNotes } from '../../hooks/useFetchDeliveryNotes'
import { DeliveryNotesList } from './elements/DeliveryNotesList'

export const DeliveryNotes = (): ReactElement => {
  const { t } = useTranslation()
  const { deliveryNotes, isError, isLoading } = useFetchDeliveryNotes()

  return (
    <ModuleLayout title={t('delivery_notes')}>
      <SectionMessage variant="warning">{t('delivery_notes.banner.info')}</SectionMessage>
      <Space size="s16" />
      <DeliveryNotesList deliveryNotes={deliveryNotes} isError={isError} isLoading={isLoading} />
    </ModuleLayout>
  )
}
